import messages from '../locales/fi_FI.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'fi-FI',
};
export default lang;
